import { Suspense, useState } from 'react'
import { ISection } from '../../../models/ISection'
import FallBackImage from '../../components/FallBackImage';
import Link from 'next/link';
import { ILocalizedParams } from '../../../models/ICommon';
import dynamic from 'next/dynamic';
import Loader from '../../components/svg/Loader';
const Swiper = dynamic(() => import('./Swiper'), {loading: () => <Loader/>});


export default function SectionOne(data: ISection) {
  const [selected, setSelected] = useState(0);
  const item = data.posts[selected];

  if (!item) return null;

   const isExclusive = item.newsType === 1;
  const isPrivate = item.newsType === 2;

  return (
    <section className='mb-[48px]'>
 {isExclusive ? <div className='absolute right-0 z-[2] desktop:rounded-tr-[12px] rounded-bl-[12px] h-[33px] w-[68px] top-0 px-[12px] py-[6px] text-white bg-secondary grid place-items-center !text-[16px]'>حصري</div> : null}
      {isPrivate? <div className='absolute right-0 z-[2] desktop:rounded-tr-[12px] rounded-bl-[12px] h-[33px] w-[68px] top-0 px-[12px] py-[6px] text-white bg-primary grid place-items-center !text-[16px]'>خاص</div> : null}
      
    <div className='flex flex-col justify-end h-[calc(80vh-106px)] tablet:h-[unset] tablet:aspect-[16/9] w-full relative' key={data.id}>

      <Link className='w-full h-full absolute top-0 left-0 rounded-b-[12px] tablet:rounded-b-0 desktop:rounded-b-[12px]' href={`/${!data.automated || data.targetType === 1 ? item.category.uniqueCode : data.targetSlug}/${item.uniqueCode}`} hrefLang={'ar'} title={item.title}>
        <FallBackImage key={item.image} thumbnail={item.thumbnail} src={item.image} eager sizes='100vw' alt={item.imageAlt || ''} className='w-full h-full desktop:rounded-[12px] tablet:rounded-b-0 desktop:rounded-b-[12px] object-cover' />
      </Link>
          <div className='absolute bottom-0 left-0 h-[85%] tablet:h-[35%] w-full bg-gradientBanner desktop:rounded-b-[12px] pb-[24px] tablet:pb-0' />
         <div className='flex flex-col relative h-fit gap-[24px] px-0 desktopSm:!px-[24px] desktop:px-[132px] mb-[24px] desktop:mb-0 translate-y-[70px] desktop:translate-y-0 desktop:pb-[24px]'>
          
          <div className='flex flex-col gap-y-[20px]'>
          {/* <h2 className='h6 grid place-items-center px-[10px] py-[8px] bg-[rgba(255,255,255,0.92)] text-primary w-fit rounded-[6px] tablet:h-[40px] h-[36px] font-bold !leading-none'>{`جديد فوشيا`}</h2> */}
          {item.title ? <Link href={`/${!data.automated || data.targetType === 1 ? item.category.uniqueCode : data.targetSlug}/${item.uniqueCode}`} className='text-white h1 desktop:max-w-[85%]'>{item.title}</Link> : null}
          </div>

      <div className='min-h-[90px] w-full'>
        <Suspense fallback={<></>}>
          <Swiper
            selected={selected}
            data={data.posts || []}
            setSelected={(idx: number) => setSelected(idx)}
            />
        </Suspense>
      </div>
    </div>
    </div> 
    </section>
  )
}